import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function HeroHome() {
  return (
    <section className="relative group">
      <Carousel 
        showThumbs={false} 
        showStatus={false} 
        infiniteLoop 
        autoPlay 
        interval={5000} 
        transitionTime={800} 
        showArrows={true}
        className="shadow-2xl"
      >
        <div>
          <img alt="" src={require("../assets/banner_2.jpg")} className="object-cover h-[400px] md:h-[650px] w-full" />
        </div>
        <div>
          <img alt="" src={require("../assets/banner_1.jpg")} className="object-cover h-[400px] md:h-[650px] w-full" />
        </div>
        <div>
          <img alt="" src={require("../assets/banner_3.jpg")} className="object-cover h-[400px] md:h-[650px] w-full" />
        </div>
      </Carousel>
      {/* Bottom gradient mask for smooth transition to CTA */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-bgWarm to-transparent z-10 pointer-events-none"></div>
    </section>
  );
}
